var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458 0.976607L10.0859 0.225787C9.88033 0.0201807 9.54063 0.0201807 9.32608 0.225787L5.53575 4.016L1.67398 0.154272C1.46829 -0.0514239 1.12859 -0.0514239 0.914128 0.154272L0.154273 0.914121C-0.0514243 1.11973 -0.0514243 1.45942 0.154273 1.67397L4.00719 5.52685L0.225789 9.3261C0.0201809 9.5317 0.0201809 9.8714 0.225789 10.0859L0.985644 10.8458C1.19125 11.0514 1.53095 11.0514 1.7455 10.8458L5.53575 7.05549L9.32608 10.8458C9.53169 11.0514 9.87139 11.0514 10.0859 10.8458L10.8458 10.0859C11.0514 9.88034 11.0514 9.54064 10.8458 9.3261L7.04652 5.53579L10.8369 1.74557C11.0514 1.53085 11.0514 1.19115 10.8458 0.976607Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.57640cd1d987ae941cdbbbd09032177c.svg";
export { ForwardRef as ReactComponent };